/*
Copyright 2022 by Herbert Potechius,
Ernst-Abbe-Hochschule Jena - University of Applied Sciences - Department of Electrical Engineering and Information
Technology - Immersive Media and AR/VR Research Group.
All rights reserved.
This file is released under the "MIT License Agreement".
Please see the LICENSE file that should have been included as part of this package.
*/
import * as THREE from "three"


class SystemConfiguration {
    static type_list = []

    static mesh_out = null
    static zip_file =  null
    static mtl_file =  null
    static mesh_name =  null
    
    static scene_out = null

    static precomputationEnabled = true

    static material = null
    static material_keep = null
    static mesh = null

    static template_texture = new THREE.TextureLoader().load(window.location.href + "/assets/template_texture.png")


    static perspeciveCamera = null

    static textureEnabled = true
    static wireframeEnabled = false
    static xrayEnabled = false
    static lightEnabled = true

    static mesh_data = null

    // texture, shading, mask, normal, height
    static active_type = null
    static active_time = "0_07-00"

    /*
    example:
    database_sets = [
        {"folder_name": "name1",
         "file_paths": ["file1", file2, file3]},
        {"folder_name": "name2",
         "file_paths": ["file1", file2, file3]},
    ]
    */
    static database_sets = []
}

export default SystemConfiguration